<template lang="pug">
    el-dialog(title="添加第六人",:fullscreen="false",:visible.sync="visible" width="60%" :append-to-body='true' :modal-append-to-body='false' @close="closeForm()")
        el-row
            el-card(shadow="never")
                div(slot="header")
                    el-row
                        el-col(:span='11')
                            el-form-item(label="会员姓名")
                                el-input(v-model='memberName' clearable='', style='width:60%;' placeholder="请输入姓名")
                        el-col(:span='11')
                            el-form-item(label="会员账号")
                                el-input(v-model='memberMobile' clearable='', style='width:60%;' placeholder="请输入手机号码")
                        el-col(:span='2')
                            el-button(@click="getSixManList" style='float:right;' icon='el-icon-search') 查询
                div
                    el-table(ref="sixManList" @row-click="sixManDataCurrentChange" :data="sixManList" border highlight-current-row  @current-change="sixManDataCurrentChange" max-height="300" )
                        el-table-column(header-align='center' label='序号' align='center'  width='60')
                            template(scope="scope")
                                el-radio(class="radio" v-model="radio" :label="scope.$index+1")
                        el-table-column(prop="name" label="姓名" align='center')
                        el-table-column(prop="gender" label="性别" align='center' )
                            template(slot-scope="scope")
                                font(v-if="scope.row.gender === 0") 男
                                font(v-if="scope.row.gender === 1") 女
                        el-table-column(prop="level" label="级别" align='center' )
                        el-table-column(prop="mobile" label="手机号码" align='center' )
                        //- el-table-column(type="selection" align='center')
        span.dialog-footer(slot="footer")
            el-button(@click="addSixManSubmit" type="primary") 确 定
            el-button(@click="visible=false") 取 消
</template>
<script>
export default {
  data () {
    return {
        visible: false,
        radio: '',
        sixManList: [], //第六人列表
        sixMan: {}, //选中的参赛第六人
        ruleForm: {},
        memberName: '',
        memberMobile: '',
        selectEnrollData: {},
        enrollMember: {}

    }
  },
  methods: {
    openFullScreen () {
      this.loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
      })
    },
    //添加第六人
    init (row, ruleForm) {
        this.visible = true
        if (ruleForm) {
          this.ruleForm = ruleForm
        }
        this.memberName = ''
        this.memberMobile = ''
        this.selectEnrollData = row
    },
    getSixManList () {
        this.sixMan = {}
        this.enrollMember = {}
        this.enrollMember.ctId = this.ruleForm.id
        this.enrollMember.id = this.selectEnrollData.id
        this.$http({
            url: this.$http.adornUrl(`/mbMember/getSixManMbList`),
            method: 'GET',
            params: this.$http.adornParams({
                'cbId': this.selectEnrollData.participantInfoId,
                'name': this.memberName,
                'mobile': this.memberMobile
            })
        }).then(data => {
            console.log('第六人会员列表：', data)
            if (data && data.code === 0) {
                this.sixManList = data.list
            } else {
                this.sixManList = []
            }
        })
    },
    //选择第六人
    sixManDataCurrentChange (val) {
        //赋值给radio
        this.radio = this.sixManList.indexOf(val) + 1
        this.sixMan = val
    },
    //添加第六人
    addSixManSubmit () {
        console.log('添加第六人：', this.sixMan)
        if (!this.sixMan || !this.sixMan.id) {
            this.$message.error('请选择第六人')
            return
        }
        console.log('第六人：', this.sixMan)
        this.openFullScreen()
        this.$http({
            url: this.$http.adornUrl(`/elEnroll/addSixMan`),
            method: 'post',
            params: this.$http.adornParams({
                'cbId': this.selectEnrollData.participantInfoId,
                'mbId': this.sixMan.id,
                'enrollId': this.selectEnrollData.id
            })
        }).then(data => {
            console.log(data)
            if (data && data.code === 0) {
                if (!data.state) {
                    this.$message.error(data.info)
                } else {
                    this.$message.success('添加成功!')
                    this.visible = false
                    this.$emit('refreshDataList')
                }
            } else {
                this.$message.success('添加失败!')
            }
            this.loading.close()
        })
    },
    closeForm () {
      this.visible = false
    }

  }
}
</script>
